export default "__VITE_ASSET__ZLpfR$Fv__"